import type { PostCalculationMemberSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { UserPicker } from "@/components/pickers/user-picker";

/** Props Interface */
interface CalculationMemberFormProps {
	excludeUserIds: string[];
}

export function CalculationMemberForm({ excludeUserIds }: CalculationMemberFormProps) {
	/** Hooks */
	const methods = useFormContext<PostCalculationMemberSchema>();

	/** Render */
	return (
		<UserPicker
			control={methods.control}
			name="userId"
			excludeUserIds={excludeUserIds}
		/>
	);
}
